import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { AppComponent } from 'src/app/app.component';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
import { RegionBackendService } from 'src/app/region/services/regions.service';
import { Region } from 'src/app/region/models/region.interface';
import { Subscription } from 'rxjs';
import {
  extractShopCompanies,
  ShopCompany,
} from 'src/app/components/shop-companies/shop-company.models';

declare var $: any;

@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.scss']
})
export class EditClientComponent implements OnInit {
  clientId = 0;
  clientForm: FormGroup;
  loading: boolean = false;
  loadingBeneficiaries: boolean = false;
  showPassword: boolean = false;
  access: any;
  nationalIdInvalid: boolean = false;
  placeholderText: string = '';
  clientSubscriptions: any[] = [{}];
  shopCompanies: ShopCompany[] = [];
  client: any;

  beneficiaryForm: FormGroup;
  public provincias: Region[] = [];
  public cantones: Region[] = [];
  public distritos: Region[] = [];
  private _subscriptions:Subscription = new Subscription();
  public selectedProvinciaId: string = '';
  public selectedCantonId: string = '';
  public selectedDistritoId: string = '';
  provinciaName = "";
  cantonName = "";
  distritoName = "";
  beneficiaryRegionId: any;
  beneficiaryAddress: any;
  currentRelationship = "";
  validRelationships: string[] = ['Perro', 'Gato'];
  validateResponsibleRelationships: string[] = ['Perro', 'Gato', 'Hijo', 'Hija'];

  constructor(
    public appComponent: AppComponent,
    private apiService: ApiService,
    public themingService: ThemingService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private lambdaService: LambdaService,
    private readonly _region: RegionBackendService,
  ) {
    this.clientForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      gender: [''],
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
      documentType: ['', Validators.required],
      clientSubscription: [''],
      shopCompanyId: [null],
      nationalId: ['', Validators.required] ,
      isPoolRegister: [{ value: false, disabled: true }],
      username: [''],
      password: [{ value: '', disabled: true }],
      isVerifiedClient: [false],
      clientRegistrationDate: ['']
    });

    this.beneficiaryForm = this.fb.group({
      beneficiaryName: ['', Validators.required],
      beneficiaryNationalId: ['', Validators.required],
      beneficiaryBornDate: [''],
      beneficiaryGender: [''],
      beneficiaryPhone: [''],
      beneficiaryEmail: [''],
      nationalId: ['', Validators.required],
      beneficiaryLastName: ['', Validators.required],
      beneficiaryRelationship: [''],
      beneficiaryBreed: [''],
      beneficiaryColor: [''],
      beneficiaryDocumentType: [''],
      selectedProvinciaId: [''],
      selectedCantonId: [''],
      selectedDistritoId: [''],
      beneficiaryAddress: ['']
    });

    this.route.paramMap.subscribe((params) => {
      let clientId = Number(params.get('clientId'));
      if (clientId != this.clientId) {
        this.appComponent.goToTop();
        this.clientId = clientId;
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await this.getSubscriptions();
    await this.getShopCompanies();
    await this.getClient();
    this.handlePhoneInput();
    this.handleIsPoolRegisterToggle();
    this.clientForm.get('nationalId')?.valueChanges.subscribe(value => {
      this.validateNationalId(value);
    });

    this.beneficiaryForm.get('nationalId')?.setValue(this.client.nationalId);
    this.clientForm.get('documentType')?.valueChanges.subscribe(type => {
      this.placeholderText = type === 'Passport'
        ? 'Ej: A12345678900'
        : (type === 'DIMEX'
          ? 'Ej: 12345678901'
          : (type === 'other'
          ? ''
          : 'Ej: 123456789'));
      this.validateNationalId(this.clientForm.get('nationalId')?.value || '');
    });
    this._subscriptions.add(
      this._region.getSubregions(this._region.crId)
      .subscribe(value => {
          this.provincias = value;
      })
    );
    console.log("provincias: ",this.provincias)
  }

  createBeneficiaries(): void {
    this.validateBeneficiaryNationalId();
    console.log("creando")
    if (this.nationalIdInvalid) {
      console.error('The ID number is invalid.');
      return;
    }
    console.log("this.beneficiaryForm.valid",this.beneficiaryForm.valid)
    if (this.beneficiaryForm.valid) {
      this.loadingBeneficiaries = true;
      const resourceData = this.beneficiaryForm.value;

      this.lambdaService.createBeneficiaries(
        this.themingService.shopTheming[0].shopId,
        resourceData.beneficiaryName,
        resourceData.beneficiaryNationalId,
        resourceData.beneficiaryBornDate,
        resourceData.beneficiaryGender,
        resourceData.beneficiaryPhone,
        resourceData.beneficiaryEmail,
        resourceData.nationalId,
        resourceData.beneficiaryLastName,
        resourceData.beneficiaryRelationship,
        resourceData.beneficiaryBreed,
        resourceData.beneficiaryColor,
        resourceData.beneficiaryDocumentType,
        resourceData.selectedDistritoId,
        resourceData.beneficiaryAddress,
        this.provinciaName,
        this.cantonName,
        this.distritoName
      )
        .then((response: any) => {
          console.log("response",response)
          const isCreated = response.data?.isCreated;
          const statusCode = response.statusCode ?? response.data?.statusCode;

          if (statusCode == 200 && isCreated == 1) {
            this.showSuccessModal();

          } else if (statusCode == 409 && isCreated == 0) {
            $('#errorTwoBeneficiariesModal').modal('show');

          } else {
            this.showGenericErrorModal();
          }
        })
        .catch((error) => {
          console.error("Error en la API:", error);
          this.showGenericErrorModal();
        })
        .finally(() => {
          this.loadingBeneficiaries = false;
        });
    }
  }

  onProvinciaChange(event: Event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    // const selectedId = this.beneficiaryForm.get('selectedProvinciaId')?.value;
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = selectElement.value; // esto es el ID
    this.provinciaName = selectElement.options[selectElement.selectedIndex]?.text; // esto es el nombre
    console.log(this.provinciaName)
    this.selectedProvinciaId = selectedId;
    this.cantones = [];
    this.distritos = [];
    if (selectedId) {
      this._subscriptions.add(
        this._region.getSubregions(selectedId).subscribe((response) => {
          this.cantones = response;
        })
      );
    }
  }

  onCantonChange(event: Event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    // const selectedId = this.beneficiaryForm.get('selectedProvinciaId')?.value;
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = selectElement.value; // esto es el ID
    this.cantonName = selectElement.options[selectElement.selectedIndex]?.text; // esto es el nombre
    console.log(this.cantonName)
    this.selectedCantonId = selectedId;
    this.distritos = [];
    if (selectedId) {
      this._subscriptions.add(
        this._region.getSubregions(selectedId).subscribe((response) => {
          this.distritos = response;
        })
      );
    }
  }

  onDistritoChange(event: Event) {
    // const selectedId = (event.target as HTMLSelectElement).value;
    // const selectedId = this.beneficiaryForm.get('selectedProvinciaId')?.value;
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = selectElement.value; // esto es el ID
    this.distritoName = selectElement.options[selectElement.selectedIndex]?.text; // esto es el nombre
    console.log(this.distritoName)
    this.selectedDistritoId = selectedId;
    this.beneficiaryRegionId = selectedId;
  }

  onChangeRelationship(event: any) {
    this.currentRelationship = event.target.value;
  }

  validateBeneficiaryNationalId(): void {
    const value = this.beneficiaryForm.get('beneficiaryNationalId')?.value || '';
    const type = this.beneficiaryForm.get('beneficiaryDocumentType')?.value;

    if (type === 'ID') {
      this.nationalIdInvalid = !(value.length === 9 && /^\d+$/.test(value));
    } else if (type === 'Passport') {
      this.nationalIdInvalid = !/^[A-Z][0-9]{8,11}$/.test(value);
    } else if (type === 'DIMEX') {
      this.nationalIdInvalid = !/^[1-9][0-9]{11}$/.test(value);
    } else if (type === 'other') {
      this.nationalIdInvalid = value.length === 0; // Inválido si está vacío
    } else {
      this.nationalIdInvalid = false;
    }
  }

  updateBeneficiaryNationalIdValidators(relationship: string): void {
    if (this.validRelationships.includes(relationship)) {
      // Si el valor está en el arreglo, quitar la validación
      this.beneficiaryForm.get('beneficiaryNationalId')?.clearValidators();
      this.beneficiaryForm.get('beneficiaryLastName')?.clearValidators();
    } else {
      // Si no, agregar la validación requerida
      this.beneficiaryForm.get('beneficiaryNationalId')?.setValidators(Validators.required);
      this.beneficiaryForm.get('beneficiaryLastName')?.setValidators(Validators.required);
    }
    // Actualizar el estado del control
    this.beneficiaryForm.get('beneficiaryNationalId')?.updateValueAndValidity();
    this.beneficiaryForm.get('beneficiaryLastName')?.updateValueAndValidity();
  }

  showGenericErrorModal(): void {
    $('#errorBeneficiariesModal').modal('show');
  }

  showSuccessModal(): void {
    $('#successBeneficiariesModal').modal('show');
    $('#successBeneficiariesModal').on('hidden.bs.modal', () => {
      this.beneficiaryForm.reset();
      //this.creationBeneficiarySuccess.emit();
    });
  }

  showDuplicateErrorModal(errorMessage: string): void {
    $('#errorTwoBeneficiariesModal .modal-body').text(errorMessage);
    $('#errorTwoBeneficiariesModal').modal('show');
    $('#errorTwoBeneficiariesModal').on('hidden.bs.modal', () => {

    });
  }

  closeBeneficiariesModal() {
    $('#successBeneficiariesModal').modal('hide');
    $('#errorBeneficiariesModal').modal('hide');
    $('#requiredBeneficiariesModal').modal('hide');
    $('#errorTwoBeneficiariesModal').modal('hide');
  }

  async getClient() {
    this.loading = true;
    try {
      const data: any = await this.lambdaService.getClient(this.themingService.shopId, this.clientId);
      //this.clientForm.patchValue(data.client);
      this.client = data.client;
      // Mapea los datos correctamente al FormGroup
      const formData = {
        ...data.client,  // Copia todas las propiedades existentes
        clientSubscription: this.client.clientSubscriptionId || '',  // Mapea clientSubscriptionId al FormControl clientSubscription
        shopCompanyId: this.normalizeShopCompanyId(
          this.client.shopCompanyId
        ),
        clientRegistrationDate: this.addSixHours(this.client.registrationDate)
      };
      this.clientForm.patchValue(formData);
      const username = data.client.username || '';
      this.toggleControlsBasedOnUsername(username);

    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  }

  addSixHours(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    date.setHours(date.getHours() + 6);
    return date.toISOString();
  }

  handlePhoneInput(): void {
    this.clientForm.get('phone')?.valueChanges.subscribe((value) => {
      if (value && !value.startsWith('+')) {
        this.clientForm.get('phone')?.setValue('+' + value, { emitEvent: false });
      }
    });
  }

  handleIsPoolRegisterToggle(): void {
    this.clientForm.get('isPoolRegister')?.valueChanges.subscribe((isPoolRegister) => {
      if (isPoolRegister && !this.clientForm.get('username')?.value) {
        this.clientForm.get('password')?.enable();
      } else {
        this.clientForm.get('password')?.disable();
        this.clientForm.get('password')?.reset();
        this.showPassword = false;
      }
    });
  }

  generatePassword(): void {
    if (this.clientForm.get('password')?.enabled) {
      const length = 12;
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
      let password = "";
      for (let i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n));
      }
      this.clientForm.controls['password'].setValue(password);
    }
  }

  togglePasswordVisibility(): void {
    if (this.clientForm.get('password')?.enabled) {
      this.showPassword = !this.showPassword;
    }
  }

  toggleControlsBasedOnUsername(username: string) {
    const isPoolRegisterControl = this.clientForm.get('isPoolRegister');
    const isPasswordControl = this.clientForm.get('password');

    if (username && username.trim() !== '') {
      isPasswordControl?.disable();
      isPoolRegisterControl?.disable();
      this.clientForm.get('isPoolRegister')?.setValue(true);
    } else {
      isPoolRegisterControl?.enable();
      isPasswordControl?.disable();
    }
  }

  onDocumentTypeChange(event: Event): void {
      const documentType = (event.target as HTMLSelectElement).value;
      this.clientForm.get('documentType')?.setValue(documentType);
      this.validateNationalId(this.clientForm.get('nationalId')?.value || '');
    }

    validateNationalId(value: string): void {
      value = value.trim();
      const documentType = this.clientForm.get('documentType')?.value;

      if (documentType === 'ID') {
        const isNumeric = /^\d+$/.test(value);
        const isValidLength = value.length === 9;
        this.nationalIdInvalid = value.length > 0 && (!isNumeric || !isValidLength);
      } else if (documentType === 'Passport') {
        this.nationalIdInvalid = !/^[A-Z][0-9]{8,11}$/.test(value);
      } else if (documentType === 'DIMEX') {
      this.nationalIdInvalid = !/^[1-9][0-9]{11}$/.test(value);
      } else {
        this.nationalIdInvalid = false;
      }

      this.clientForm.get('nationalId')?.setErrors(this.nationalIdInvalid ? { invalid: true } : null);
    }

  async getSubscriptions() {
    this.loading = true;
    try {
      let response: any = await this.lambdaService.getClientSubscriptions(this.themingService.shopId);
      this.clientSubscriptions = response.subscriptions;
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }

  async getShopCompanies() {
    try {
      const response: any = await this.lambdaService.getShopCompanies(
        this.themingService.shopId,
        true
      );
      this.shopCompanies = extractShopCompanies(response).filter(
        (company) => company.status === 1
      );
    } catch (error) {
      console.error('Error loading shop companies:', error);
      this.shopCompanies = [];
    }
  }

  formatDateToYMD(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  private normalizeShopCompanyId(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const id = Number(value);
    return Number.isFinite(id) ? id : null;
  }

  updateClient(): void {
    if (this.clientForm.valid) {
      this.loading = true;
      const clientData = this.clientForm.value;
      clientData.isVerifiedClient = clientData.isVerifiedClient ? 1 : 0;
      const shopCompanyId = this.normalizeShopCompanyId(
        clientData.shopCompanyId
      );
      // console.log(
      //   this.themingService.shopId,
      //   this.clientId,
      //   clientData.username,
      //   clientData.firstName,
      //   clientData.lastName,
      //   clientData.email,
      //   clientData.phone,
      //   clientData.nationalId,
      //   clientData.isPoolRegister,
      //   clientData.gender,
      //   clientData.password,
      //   this.access = clientData.password,
      //   clientData.isVerifiedClient,
      //   clientData.documentType,
      //   clientData.clientSubscription
      // )
      this.lambdaService.updateClient(
        this.themingService.shopId,
        this.clientId,
        clientData.username,
        clientData.firstName,
        clientData.lastName,
        clientData.email,
        clientData.phone,
        clientData.nationalId,
        clientData.isPoolRegister,
        clientData.gender,
        clientData.password,
        this.access = clientData.password,
        clientData.isVerifiedClient,
        clientData.documentType,
        clientData.clientSubscription,
        this.formatDateToYMD(clientData.clientRegistrationDate),
        shopCompanyId
      ).then((data: any) => {
        this.loading = false;
        if (data.statusCode === 200) {
          $('#successEditClientModal').modal('show');
          $('#successEditClientModal').on('hidden.bs.modal', () => {
            this.router.navigate(['/clients']);
          });
        } else {
          $('#errorEditClientModal').modal('show');
        }
      }).catch((error) => {
        console.log(error);
        $('#errorEditClientModal').modal('show');
        this.loading = false;
      });
    } else {
      console.log("no valid")
      $('#requiredEditClientModal').modal('show');
    }
  }

  closeModal() {
    $('#successEditClientModal').modal('hide');
    $('#errorEditClientModal').modal('hide');
    $('#requiredEditClientModal').modal('hide');
  }
}
